<template>
  <h-page-container>
    <div
      class="error-page"
      :class="errorPageClass"
    >
      <div class="error-page-main">
        <p>{{ text || errorText[code] }}</p>
      </div>
    </div>
  </h-page-container>
</template>

<script>
export default {
  name: 'ErrorPage',
  props: {
    code: {
      type: [String, Number],
      default: '404'
    },
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 请注意翻译
      errorText: {
        '403': this.$t('components.error.error_403'),
        '404': this.$t('components.error.error_404'),
        '500': this.$t('components.error.error_500')
      }
    }
  },
  computed: {
    errorPageClass () {
      let code = this.code
      let ret = [`error-${code}`]
      if (Number.parseInt(code) === 403 || Number.parseInt(code) === 404 || Number.parseInt(code) === 500) {
        ret.push('error-full-page')
      }
      return ret
    }
  }
}
</script>

<style lang="less" scoped>
.error-page {
  width: 100%;
  height: 100%;
  transition: all 0.2s ease-in-out;
  &.error-full-page {
    background-color: #fff;
  }
}
.error-page-main {
  position: absolute;
  top: 50%;
  width: 100%;
  height: 460px;
  margin-top: -250px;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    width: 480px;
    height: 400px;
    margin: auto;
  }
  p {
    position: absolute;
    top: 420px;
    width: 100%;
    padding: 0 32px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
}
.error-403 .error-page-main:before {
  background: url("~@/assets/images/error403.png") no-repeat;
}
.error-404 .error-page-main:before {
  background: url("~@/assets/images/error404.png") no-repeat;
}
.error-500 .error-page-main:before {
  background: url("~@/assets/images/error500.png") no-repeat;
}
</style>
